<script>
import NavBar from '../components/nav-bar'
import SideBar from '../components/side-bar'
import Footer from '../components/footer'
import { enableCSRF } from '@/api/user'

export default {
  components: { NavBar, SideBar, Footer },
  computed: {
    sidebarOpened() {
      return this.$store.getters.sidebar.opened
    }
  },
  mounted: () => {
    enableCSRF().then(() => {

    }).catch(() => {

    })
  },
  methods: {
    toggleMenu() {
      document.body.classList.toggle('sidebar-enable')

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        document.body.classList.toggle('vertical-collpsed')
      } else {
        // eslint-disable-next-line no-unused-vars
        document.body.classList.remove('vertical-collpsed')
      }
      this.$store.dispatch('app/toggleSideBar')
    }
  }
}
</script>

<template>
  <div id="layout-wrapper">
    <NavBar />
    <SideBar :is-condensed="sidebarOpened" />
    <!-- ============================================================== -->
    <!-- Start Page Content here -->
    <!-- ============================================================== -->

    <div class="main-content">
      <div class="page-content">
        <!-- Start Content-->
        <div class="container-fluid">
          <router-view />
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>
